/**
 * google.ts — o que o Google Identity Services precisa saber quando alguém
 * sai do sistema.
 *
 * Sem isto, o botão de login continuava anunciando "Fazer login como
 * Fulano" com o e-mail à mostra depois do logout: quem usa o computador em
 * seguida — numa prefeitura, o balcão é compartilhado — via o nome e o
 * endereço de quem acabou de sair.
 */

/** Tipagem mínima do que usamos do GIS (o script é carregado sob demanda). */
interface ContasGoogle {
  accounts?: { id?: { disableAutoSelect?: () => void } }
}

/**
 * Marca no Google que a pessoa saiu daqui.
 *
 * `disableAutoSelect` é o método documentado para chamar no logout do site:
 * impede que o One Tap torne a entrar sozinho na próxima visita. Não derruba
 * a sessão do Google no navegador — isso é do Google, não nosso — e por isso
 * o botão também é renderizado sem personalização (ver BotaoGoogle.tsx).
 */
export function esquecerContaGoogle() {
  const google = (window as unknown as { google?: ContasGoogle }).google
  try {
    google?.accounts?.id?.disableAutoSelect?.()
  } catch {
    /* script não carregado nesta página: nada a esquecer */
  }
}
